import { BASE_URL_LEGACY } from "./";

export const applianceService = {
  getDetail,
};

function getDetail(user, id) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/common/appliances/${id}/?user_id=${user}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}
